import {util} from '@nuskin/ns-util'

let FirebaseProductParser = function(productSku, language, firebaseProduct){
    // Define the tags
    let LANGUAGES = "languages";
    let IMAGE_URL = "image";
    let NAME = "name";
    let LONG_DESCRIPTION = "long";
    let SHORT_DESCRIPTION = "short";
    let SIZE = "size";

    let MARKET_DATA = "marketData";
    let PRICING = "pricing";
    let SCAN_QUALIFIED = "scanQualified";
    let SEARCHABLE = "searchable";
    let SEA_SHOPPE = "seashoppe";
    let STATUS_CODE = "statusCode";
    let ORDER_TYPE = "orderType";
    let AVAILABLE = "available";
    let CUST_TYPE = "custType";

    let ADR_PREFERRED = "adrPrf";
    let ADR_RETAIL = "adrRtl";
    let ADR_WHOLESALE = "adrWhl";
    let POINTS = "pts";
    let PREFERRED = "prf";
    let RETAIL = "rtl";
    let WHOLESALE = "whl";
    let WEB_ADR_RETAIL = "wAdrRtl";
    let WEB_ADR_WHOLESALE = "wAdrWhl";
    let WEB_PREFERRED = "wPrf";
    let WEB_RETAIL = "wRtl";
    let WEB_WHOLESALE = "wWhl";
    let WEB_ADR_RETAIL_CV = "wAdrRtlCv";
    let WEB_WHOLESALE_CV = "wWhlCv";
    let WEB_ADR_RETAIL_PV = "wAdrRtlPv";
    let WEB_WHOLESALE_PV = "wWhlPv";

    let ORDER_TYPE_ADR = 'adr';
    let ORDER_TYPE_ORDER = 'order';

    let DISTRIBUTOR = '10';
    let CUSTOMER = '20';
    let PREFERRED_CUSTOMER = '30';

    let sku;
    let lang;
    let product;

    let languageStrings;
    let marketData;
    let pricing;

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    let publicMethods = {
        doesLanguageExistForProduct: function(language){
            return product && product[LANGUAGES] && product[LANGUAGES][language];
        },
        doesMarketDataAndPricingExistForProduct: function(){
            return product && product[MARKET_DATA] && product[PRICING];
        },
        getSku: function(){
            return sku;
        },
        getLanguage: function(){
            return lang;
        },
        getFullImageUrl: function(){
            return languageStrings ? util.MobileUtils.checkPath(languageStrings[IMAGE_URL] + ".img.240.240.png", true) : "";
        },
        getImageUrl: function(){
            return languageStrings ? util.MobileUtils.checkPath(languageStrings[IMAGE_URL] + ".img.64.64.png", true) : "";
        },
        getName: function(){
            return languageStrings ? languageStrings[NAME] : "";
        },
        getSize: function(){
            return languageStrings ? languageStrings[SIZE] : "";
        },
        getShortDescription: function(){
            return languageStrings ? languageStrings[SHORT_DESCRIPTION] : "";
        },
        getLongDescription: function(){
            return languageStrings ? languageStrings[LONG_DESCRIPTION] : "";
        },
        getScanQualified: function(){
            return marketData ? marketData[SCAN_QUALIFIED] : false;
        },
        getAvailable: function(){
            return marketData ? marketData[AVAILABLE] : false;
        },
        getSearchable: function(){
            return marketData ? marketData[SEARCHABLE] : false;
        },
        getSeashoppe: function(){
            return marketData ? marketData[SEA_SHOPPE] : false;
        },
        getStatusCode: function(){
            return marketData ? marketData[STATUS_CODE] : 0;
        },
        getWebEnabled: function(){
            // All firebase products are WEB enabled.
            return true;
        },

        // ---------------------------------------------
        //
        //        Pricing Methods
        //
        // ---------------------------------------------
        getAdrPreferredPrice: function(){
            return insureFloat(pricing && pricing[ADR_PREFERRED] ? pricing[ADR_PREFERRED] : "0.00");
        },
        getAdrRetailPrice: function(){
            return insureFloat(pricing && pricing[ADR_RETAIL] ? pricing[ADR_RETAIL] : "0.00");
        },
        getAdrWholesalePrice: function(){
            return insureFloat(pricing && pricing[ADR_WHOLESALE] ? pricing[ADR_WHOLESALE] : "0.00");
        },
        getPoints: function(){
            return insureFloat(pricing && pricing[POINTS] ? pricing[POINTS] : "0.00");
        },
        getPreferredPrice: function(){
            return insureFloat(pricing && pricing[PREFERRED] ? pricing[PREFERRED] : "0.00");
        },
        getRetailPrice: function(){
            return insureFloat(pricing && pricing[RETAIL] ? pricing[RETAIL] : "0.00");
        },
        getWholesale: function(){
            return insureFloat(pricing && pricing[WHOLESALE] ? pricing[WHOLESALE] : "0.00");
        },
        getWebAdrRetailPrice: function(){
            return insureFloat(pricing && pricing[WEB_ADR_RETAIL] ? pricing[WEB_ADR_RETAIL] : "0.00");
        },
        getWebAdrWholesalePrice: function(){
            return insureFloat(pricing && pricing[WEB_ADR_WHOLESALE] ? pricing[WEB_ADR_WHOLESALE] : "0.00");
        },
        getWebPreferredPrice: function(){
            return insureFloat(pricing && pricing[WEB_PREFERRED] ? pricing[WEB_PREFERRED] : "0.00");
        },
        getWebRetailPrice: function(){
            return insureFloat(pricing && pricing[WEB_RETAIL] ? pricing[WEB_RETAIL] : "0.00");
        },
        getWebWholesalePrice: function(){
            return insureFloat(pricing && pricing[WEB_WHOLESALE] ? pricing[WEB_WHOLESALE] : "0.00");
        },
        getWebAdrRetailCv: function(){
            return insureFloat(pricing && pricing[WEB_ADR_RETAIL_CV] ? pricing[WEB_ADR_RETAIL_CV] : "0.00");
        },
        getWebWholesaleCv: function(){
            return insureFloat(pricing && pricing[WEB_WHOLESALE_CV] ? pricing[WEB_WHOLESALE_CV] : "0.00");
        },
        getWebAdrRetailPv: function(){
            return insureFloat(pricing && pricing[WEB_ADR_RETAIL_PV] ? pricing[WEB_ADR_RETAIL_PV] : "0.00");
        },
        getWebWholesalePv: function(){
            return insureFloat(pricing && pricing[WEB_WHOLESALE_PV] ? pricing[WEB_WHOLESALE_PV] : "0.00");
        },

        isOrderTypeADR: function(){
            let isADR = false;

            if (marketData) {
                let orderType = marketData[ORDER_TYPE];

                if (orderType) {
                    for (let i = 0; i < orderType.length; i++) {
                        if (orderType === ORDER_TYPE_ADR) {
                            isADR = true;
                            break;
                        }
                    }
                }
            }

            return isADR;
        },
        isOrderTypeOrder: function(){
            let isOrder = false;

            if (marketData) {
                let orderType = marketData[ORDER_TYPE];

                if (orderType) {
                    for (let i = 0; i < orderType.length; i++) {
                        if (orderType === ORDER_TYPE_ORDER) {
                            isOrder = true;
                            break;
                        }
                    }
                }
            }

            return isOrder;
        },
        getOrderTypes: function(){
            return marketData && marketData[ORDER_TYPE] ? marketData[ORDER_TYPE] : [];
        },
        isCustomerTypeDistributor: function(){
            let isDistributor = false;

            if (marketData) {
                let custType = marketData[CUST_TYPE];

                if (custType) {
                    for (let i = 0; i < custType.length; i++) {
                        if (custType === DISTRIBUTOR) {
                            isDistributor = true;
                            break;
                        }
                    }
                }
            }

            return isDistributor;
        },
        isCustomer: function(){
            let isCustomer = false;

            if (marketData) {
                let custType = marketData[CUST_TYPE];

                if (custType) {
                    for (let i = 0; i < custType.length; i++) {
                        if (custType === CUSTOMER) {
                            isCustomer = true;
                            break;
                        }
                    }
                }
            }

            return isCustomer;
        },
        isPreferredCustomer: function(){
            let isPreferred = false;

            if (marketData) {
                let custType = marketData[CUST_TYPE];

                if (custType) {
                    for (let i = 0; i < custType.length; i++) {
                        if (custType === PREFERRED_CUSTOMER) {
                            isPreferred = true;
                            break;
                        }
                    }
                }
            }

            return isPreferred;
        },
        getCustomerTypes: function(){
            return marketData && marketData[CUST_TYPE] ? marketData[CUST_TYPE] : [];
        }
    };

    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------
    function createParser(productSku, language, firebaseProduct){
        sku = productSku;
        lang = language;
        product = firebaseProduct;

        if (product) {
            languageStrings = product[LANGUAGES] ? product[LANGUAGES][lang] : undefined;
            marketData = product[MARKET_DATA];
            pricing = product[PRICING];
        }
    }
    function insureFloat(price){
        let floatPrice = parseFloat(price);
        return isNaN(floatPrice) ? 0.00 : floatPrice;
    }

    // Construct the object.
    createParser(productSku, language, firebaseProduct);

    return publicMethods;
};

export default FirebaseProductParser;